import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SimpleCard from '../../components/SimpleCard';

function PhotoGallery({ section }) {
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [headingText, setHeadingText] = useState('Gallery'); // Default fallback

  useEffect(() => {
    const fetchGalleryItems = async () => {
      try {
        setLoading(true);
        const res = await axios.get('/api/gallery-items');
        const matchedItem = res.data.find(item => item.section === section);

        if (matchedItem) {
          // Set heading from slider description if it's a slider, else use section
          const heading = matchedItem.isSlider
            ? matchedItem.sliderImgDescription || 'Slider Gallery'
            : matchedItem.section || 'Gallery';

          setHeadingText(heading);

          const formatted = matchedItem.images?.map((image, index) => {
           console.log(matchedItem._id);

           return {
           text: image.imgDescription || 'No description',
          img: `/api/gallery-items/img/${matchedItem._id}/${index}`,
         };
        }) || [];

          setGalleryItems(formatted);
        } else {
          setGalleryItems([]);
          setHeadingText('Gallery');
        }

        setError(null);
      } catch (err) {
        console.error('Error fetching gallery items:', err);
        setError('Failed to load gallery items.');
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryItems();
  }, [section]);

  if (loading) return <div>Loading gallery...</div>;
  if (error) return <div>{error}</div>;
  if (!galleryItems.length) return <div>No images available for this section.</div>;

  return (
    <div>
      <div className="body">
        <div className="heading">{headingText}</div>
        <hr /><hr />

        <div className="body">
          {/* Inline styles for photo gallery container */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'center',
            padding: '20px'
          }}>
            {galleryItems.map((item, index) => (
              <div
                key={index}
                style={{
                  width: '300px', // Fixed width for each card
                
                  overflow: 'hidden', // Prevent overflow
                  position: 'relative',
                  background: '#fff',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                {/* Image styling */}
                <img
                  src={item.img}
                  alt="gallery-item"
                  style={{
                    width: '100%',
                    height: '200px', // Fixed image height
                    objectFit: 'cover' // Ensure image covers the space without distortion
                  }}
                />
                {/* Description styling */}
                <div
                  style={{
                    padding: '10px',
                    fontSize: '14px',
                    color: '#333',
                    textAlign: 'center'
                  }}
                >
                  {item.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhotoGallery;
